var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM8.0001 4.80016C7.83036 4.80016 7.66757 4.86759 7.54755 4.98761C7.42753 5.10763 7.3601 5.27042 7.3601 5.44016V8.00016C7.3601 8.1699 7.42753 8.33268 7.54755 8.45271C7.66757 8.57273 7.83036 8.64016 8.0001 8.64016C8.16984 8.64016 8.33262 8.57273 8.45265 8.45271C8.57267 8.33268 8.6401 8.1699 8.6401 8.00016V5.44016C8.6401 5.27042 8.57267 5.10763 8.45265 4.98761C8.33262 4.86759 8.16984 4.80016 8.0001 4.80016ZM8.0001 9.92016C7.87352 9.92016 7.74978 9.9577 7.64453 10.028C7.53928 10.0983 7.45725 10.1983 7.40881 10.3152C7.36037 10.4322 7.3477 10.5609 7.37239 10.685C7.39709 10.8092 7.45804 10.9232 7.54755 11.0127C7.63705 11.1022 7.75109 11.1632 7.87524 11.1879C7.99939 11.2126 8.12807 11.1999 8.24502 11.1514C8.36196 11.103 8.46191 11.021 8.53224 10.9157C8.60256 10.8105 8.6401 10.6867 8.6401 10.5602C8.6401 10.3904 8.57267 10.2276 8.45265 10.1076C8.33262 9.98759 8.16984 9.92016 8.0001 9.92016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningFill);
export default __webpack_public_path__ + "static/media/icon-warning-fill.d08e038832d567ea271d9caa21947bc0.svg";
export { ForwardRef as ReactComponent };